import { ShareKeyData } from "app/shares/interfaces";
import React, { ReactNode } from "react";

import { formatDecimal, formatMoney, formatPercent, millionsWithCurrency } from "app/formatting/functions";
import { Box, DescriptionListEntry, DescriptionList } from "app/layout/components";
import "./style.scss";
import { DescriptionListWithDividers } from "app/layout/DescriptionList/DescriptionList";

const emptyValue = "-";

export interface Props extends ShareKeyData {
    forecastCurrency?: string;
}

/**
 * Renders a list of key data
 */
export const ShareStageAsideCard = ({
    forecast,
    forecastCurrency,
    dividendReturn,
    forecastDifference,
    quoteYieldRate,
    exchangeValue
}: Props) => {
    // gather the array of keydata to render

    const keyDataItems: { label: ReactNode; content: ReactNode }[] = [];

    let priceTarget = emptyValue;
    if (forecast && forecastCurrency) {
        priceTarget = formatMoney(forecast, forecastCurrency);
    }
    keyDataItems.push({
        label: "Analysten Prognose Kursziel",
        content: priceTarget
    });

    keyDataItems.push({
        label: "Differenz zum Kursziel",
        content: forecastDifference ? formatPercent(forecastDifference) : emptyValue
    });

    keyDataItems.push({
        label: "Dividendenrendite",
        content: dividendReturn ? formatPercent(dividendReturn) : emptyValue
    });

    keyDataItems.push({
        label: "Kurs-Gewinnverhältnis",
        content: quoteYieldRate ? formatDecimal(quoteYieldRate) : emptyValue
    });

    keyDataItems.push({
        label: "Börsenwert",
        content: exchangeValue ? millionsWithCurrency(exchangeValue.value, exchangeValue.currency) : emptyValue
    });

    return (
        <Box className={"shareStageAsideCard"}>
            <DescriptionListWithDividers>
                {keyDataItems.map(({ label, content }, i) => {
                    return <DescriptionListEntry key={i} term={label} details={content} />;
                })}
            </DescriptionListWithDividers>
        </Box>
    );
};
